import React from 'react';
import { getCredentialingProviders } from 'api/credentialing';
import { TCredentialingProvider } from 'types/credentialing';

let globalData: TCredentialingProvider[] = [];

const useCredentialProviders = (): [TCredentialingProvider[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingProvider[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingProviders();
            if (!result.error) {
                const list: TCredentialingProvider[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useCredentialProviders;
